/**
 * List of image file types supported.
 */
export const basicImageFileTypeMappings = [
    {
        fileType: 'image/jpeg',
        extensions: ['jpg', 'jpeg', 'jfif'],
    },
    {
        fileType: 'image/bmp',
        extensions: ['bmp'],
    },
    {
        fileType: 'image/png',
        extensions: ['png'],
    },
    {
        fileType: 'image/gif',
        extensions: ['gif'],
    },
    {
        fileType: 'image/heic',
        extensions: ['heic'],
    },
    {
        fileType: 'image/svg+xml',
        extensions: ['svg'],
    },
    {
        fileType: 'image/webp',
        extensions: ['webp'],
    },
    {
        fileType: 'application/pdf',
        extensions: ['pdf'],
    },
];
/**
 * List of pdf file types supported
 */
export const otherFileTypeMappings = [
    {
        fileType: 'image/vnd.adobe.photoshop',
        extensions: ['psd'],
    },
    {
        fileType: 'application/postscript',
        extensions: ['ai', 'eps'],
    },
    {
        fileType: 'application/vnd.dvb.ait',
        extensions: ['ait'],
    },
    {
        fileType: 'application/vnd.ms-powerpoint',
        extensions: ['ppt'],
    },
    {
        fileType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        extensions: ['pptx'],
    },
    {
        fileType: 'image/tiff',
        extensions: ['tif', 'tiff'],
    },
];
/**
 * Combination of all file types supported.
 */
export const allSupportedFileTypeMappings = basicImageFileTypeMappings.concat(otherFileTypeMappings);
//# sourceMappingURL=const.js.map